/**
 * Ekspresi cron -> kalimat yang dapat dibaca manajer pabrik, dalam dua bahasa.
 *
 * MENGAPA INI ADA DI KONSOL DAN BUKAN DI SERVER
 * ---------------------------------------------
 * `saved_report.schedule_cron` adalah NILAI operasional: ia dikirim ke penjadwal,
 * dan penjadwal membaca cron. Menerjemahkannya di server berarti mengirim prosa
 * dan kehilangan nilainya, atau mengirim keduanya dan menduplikasi kebenaran.
 * Yang benar adalah server tetap mengirim ekspresinya, dan LAYAR memilih kalimat
 * dari katalog — karena hanya layar yang tahu bahasa pembacanya.
 *
 * YANG TIDAK DILAKUKAN: menebak. Hanya tiga bentuk yang punya kalimat — bulanan,
 * mingguan, harian. Bentuk lain dikembalikan sebagai ekspresinya sendiri lewat
 * `reports.schedule.raw`, karena kalimat yang salah tentang KAPAN sebuah laporan
 * berisi data pribadi dikirim ke dua penerima lebih berbahaya daripada ekspresi
 * yang jujur tidak terbaca.
 */

type NilaiParam = string | number | boolean | Date | null | undefined;
type Penerjemah = (kunci: string, params?: Record<string, NilaiParam>) => string;

const DUA = (n: number) => String(n).padStart(2, '0');

export function jadwalManusiawi(cron: string | null | undefined, t: Penerjemah): string {
  if (!cron || cron.trim() === '') return t('reports.schedule.manual');

  const bagian = cron.trim().split(/\s+/);
  if (bagian.length !== 5) return t('reports.schedule.raw', { expression: cron });

  const [menit = '', jam = '', tanggal = '', bulan = '', hari = ''] = bagian;
  const angka = (s: string) => (/^\d+$/.test(s) ? Number(s) : null);
  const m = angka(menit);
  const j = angka(jam);
  if (m === null || j === null || m > 59 || j > 23) {
    return t('reports.schedule.raw', { expression: cron });
  }
  const waktu = `${DUA(j)}:${DUA(m)}`;

  const tgl = angka(tanggal);
  const hr = angka(hari);

  if (tgl !== null && tgl >= 1 && tgl <= 31 && bulan === '*' && hari === '*') {
    return t('reports.schedule.monthly', { day: tgl, time: waktu });
  }
  if (tanggal === '*' && bulan === '*' && hr !== null && hr >= 0 && hr <= 6) {
    return t('reports.schedule.weekly', {
      weekday: t(`reports.weekday.${hr}`),
      time: waktu,
    });
  }
  if (tanggal === '*' && bulan === '*' && hari === '*') {
    return t('reports.schedule.daily', { time: waktu });
  }
  return t('reports.schedule.raw', { expression: cron });
}
